import { registerComponent } from '@gig/magic-common';
import RealityCheckPrompterComponent from './reality-check-prompter.js';

var RealityCheckPrompter = registerComponent(RealityCheckPrompterComponent);

export { RealityCheckPrompter };
